import { SystemState } from './types'
import { defineState } from '../../../base/store/defineState'

export const defaultState = (): SystemState => ({
  returnCrudModel: void 0,
  returnLocation: '',
  returnLabel: '',
  completeLabel: '',
  attachModelId: void 0,
  meta: {
    title: '',
    description: '',
    keywords: '',
    ogTitle: '',
    ogImage: '',
    ogUrl: '',
    canonicalUrl: ''
  }
})

export const resetSystemState = () => {
  return defaultState()
}

export default defineState<SystemState>('system', defaultState)
